import { render, staticRenderFns } from "./Enrolment.vue?vue&type=template&id=7c4041a0&scoped=true"
import script from "./Enrolment.vue?vue&type=script&lang=js"
export * from "./Enrolment.vue?vue&type=script&lang=js"
import style0 from "./Enrolment.vue?vue&type=style&index=0&id=7c4041a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4041a0",
  null
  
)

export default component.exports